import DocumentTitle from "react-document-title";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PayPalButtons } from "@paypal/react-paypal-js";

import { fetchAdamo } from "../utils/fetchAdamo.js";

const PAYPAL_CLIENT_ID="Abgn41eSzxeWM7sid9sKhZB1ij-qcwKy_RrtUkIsxx4C5jPV0aFLzslvtdUY_mh2f3QycFjq8GRdH36t";
const PAYPAL_CLIENT_SECRET="EJFuKgf5eG3ZS-oV_acM_pNeJoSy3htvMi1okhqpoMRA0uguy944lw3QR7f915ISpE9WkSK4_UmrlUa3"
const PORT = 8888;
const base = "https://api-m.sandbox.paypal.com";

// Hibák megjelenítése
function Message({ content }) {
  return <p>{content}</p>;
}

export function Payment(props){
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  
  let order = props.order;
  delete order.payment;
  // delete order.vezetknev;
  // delete order.keresztnev;
  // delete order["contact_email"];
  // delete order["contact_phone"];
  delete order["initial_password"];
  console.log("[MiMi] [Payment] props.order:");
  console.log(order);

  /**
   * OAuth 2.0 access token kérése PayPal REST API autentikációhoz
   * @see https://developer.paypal.com/api/rest/authentication/
   */
  const generateAccessToken = async () => {
    try {
      if (!PAYPAL_CLIENT_ID || !PAYPAL_CLIENT_SECRET) {
        throw new Error("MISSING_API_CREDENTIALS");
      }
      const auth = btoa(PAYPAL_CLIENT_ID + ":" + PAYPAL_CLIENT_SECRET);

      const response = await fetch(`${base}/v1/oauth2/token`, {
        method: "POST",
        body: "grant_type=client_credentials",
        headers: {
          Authorization: `Basic ${auth}`,
        },
      });

      const data = await response.json();
      console.log("[MiMi] Access Token generated");
      return data.access_token;
    } catch (error) {
      console.error("Failed to generate Access Token:", error);
    }
  };

  /**
   * order létrehozása tranzakció indításához
   * @see https://developer.paypal.com/docs/api/orders/v2/#orders_create
   */
  const createOrderOnPayPal = async (cart) => {
    // Ha majd lesz bevásárlókosár,itt lehet betölteni
    console.log(
      "shopping cart information passed from the createOrder() callback:",
      cart,
    );

    const accessToken = await generateAccessToken();
    const url = `${base}/v2/checkout/orders`;
    const payload = {
      intent: "CAPTURE",
      purchase_units: [
        {
          amount: {
            currency_code: "HUF",
            value: "100.00",
          },
        },
      ],
    };

    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        // Uncomment one of these to force an error for negative testing (in sandbox mode only). Documentation:
        // https://developer.paypal.com/tools/sandbox/negative-testing/request-headers/
        // "PayPal-Mock-Response": '{"mock_application_codes": "MISSING_REQUIRED_PARAMETER"}'
        // "PayPal-Mock-Response": '{"mock_application_codes": "PERMISSION_DENIED"}'
        // "PayPal-Mock-Response": '{"mock_application_codes": "INTERNAL_SERVER_ERROR"}'
      },
      method: "POST",
      body: JSON.stringify(payload),
    });

    return handleResponse(response);
  };  

  /**
   * PayPal Capture a vásárlás befejezéséhez
   * @see https://developer.paypal.com/docs/api/orders/v2/#orders_capture
   */
  const captureOrderOnPayPal = async (orderID) => {
    const accessToken = await generateAccessToken();
    const url = `${base}/v2/checkout/orders/${orderID}/capture`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        // Uncomment one of these to force an error for negative testing (in sandbox mode only). Documentation:
        // https://developer.paypal.com/tools/sandbox/negative-testing/request-headers/
        // "PayPal-Mock-Response": '{"mock_application_codes": "INSTRUMENT_DECLINED"}'
        // "PayPal-Mock-Response": '{"mock_application_codes": "TRANSACTION_REFUSED"}'
        // "PayPal-Mock-Response": '{"mock_application_codes": "INTERNAL_SERVER_ERROR"}'
      },
    });

    console.log("[MiMi] [captureOrderOnPayPal] response:");
    console.log(response);

    return handleResponse(response);
  };

  async function handleResponse(response) {
    try {
      const jsonResponse = await response.json();
      return {
        jsonResponse,
        httpStatusCode: response.status,
      };
    } catch (err) {
      console.log("[MiMi] [handleResponse] error");
      const errorMessage = await response.text();
      throw new Error(errorMessage);
    }
  }

  return(
      <DocumentTitle title='Adamo'>
          <Container className="justify-content-md-center p-2 bg-light border">
              <Image src="images/adamo_logo.png" rounded></Image> <br/> <br/>
              <p className="text-start">Kérjük használja az alábbi gombokat a PayPal-on keresztüli fizetéshez.</p> <br/>
              <p className="text-start fw-bold text-danger">Figyelem! A fizetés jelenleg TESZT üzemben működik, valódi fizetés nem lehetséges.</p> <br/>
              <PayPalButtons
                style={{
                  shape: "pill",
                  //color:'blue' change the default color of the buttons
                  layout: "vertical", //default value. Can be changed to horizontal
                }}
                createOrder={async () => {
                  try {
                  const orderData = await createOrderOnPayPal(order);

                    if (orderData.jsonResponse.id) {
                      return orderData.jsonResponse.id;
                    } else {
                      const errorDetail = orderData?.details?.[0];
                      const errorMessage = errorDetail
                        ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                        : JSON.stringify(orderData);

                      throw new Error(errorMessage);
                    }
                  } catch (error) {
                    console.error(error);
                    setMessage(`Could not initiate PayPal Checkout...${error}`);
                  }
                }}
                onApprove={async (data, actions) => {
                  try {
                    const response = await captureOrderOnPayPal(data.orderID);                      

                    const orderData = response.jsonResponse;

                    // Three cases to handle:
                    //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    //   (2) Other non-recoverable errors -> Show a failure message
                    //   (3) Successful transaction -> Show confirmation or thank you message

                    console.log("[MiMi] [onApprove] orderData:");
                    console.log(orderData);

                    const errorDetail = orderData?.details?.[0];

                    if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                      console.log("[MiMi] [errorDetail if] INSTRUMENT_DECLINED ág");
                      // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                      // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                      return actions.restart();
                    } else if (errorDetail) {
                      console.log("[MiMi] [errorDetail if] else if ág");
                      // (2) Other non-recoverable errors -> Show a failure message
                      throw new Error(
                        `${errorDetail.description} (${orderData.debug_id})`,
                      );
                    } else {
                      console.log("[MiMi] [errorDetail if] else ág");
                      // (3) Successful transaction -> Show confirmation or thank you message
                      // Or go to another URL:  actions.redirect('thank_you.html');
                      const transaction =
                        orderData.purchase_units[0].payments.captures[0];
                      setMessage(
                        `Transaction ${transaction.status}: ${transaction.id}. See console for all available details`,
                      );
                      console.log(
                        "Capture result",
                        orderData,
                        JSON.stringify(orderData, null, 2),
                      );

                      // A rendelés lezárása
                      let response = await fetchAdamo("/ajax/kezdolap/finalize-order", "POST", order);
                      let json = await response.json();
                      console.log("[MiMi] backend -finalize-order- endpoint response json:");
                      console.log(json);                        

                      // .env file létrehozása Docker konténerhez
                      // response = await fetchAdamo("/ajax/kezdolap/start-docker-container", "POST", order);
                      // json = await response.json();
                      // console.log("[MiMi] backend -start-docker-container- endpoint response json:");
                      // console.log(json);
                      
                      // E-mail kiküldése a bejelentkezési adatokról
                      // response = await fetchAdamo("/ajax/kezdolap/send-login-email", "POST", order);
                      // json = await response.json();
                      // console.log("[MiMi] backend -send-login-email- endpoint response json:");
                      // console.log(json);                                            
                  
                      navigate("/payment-success");                          
                    }
                  } catch (error) {
                    console.error(error);
                    setMessage(
                      `Sajnáljuk, a tranzakció feldolgáza sikertelenül zárult...${error}`,
                    );
                  }
                }}
              />
          </Container>
      </DocumentTitle>
  )
}
